<!--
* @Name：登录页
* @Author: 刘玉
* @Date: 2021-11-30 13:54:25
* @Last Modified by: 刘玉
* @Last Modified time: 2021-11-30 13:54:25
-->
<template>
  <div class="login-container">
    <div class="login-form">
      <van-image :src="require('./img/logo.png')" />
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          label="用户名"
          placeholder="请填写用户名"
          :rules="[{ required: true }]"
          style="margin-top: 20px"
        />
        <van-field
          v-model="password"
          type="password"
          label="密码"
          placeholder="请填写密码"
          :rules="[{ required: true }]"
          style="margin-top: 20px"
        />
        <div style="margin: 16px">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    onSubmit() {
      this.$store.dispatch('user/LoginByUsername', { username: this.username, password: this.password }).then(() => {
        this.$router.push({
          path: '/todo'
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  height: 100%;
  width: 100%;
  position: absolute;
}
.login-form {
  height: 300px;
  position: relative;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}
</style>
